/**
 * Saved Searches — thin client wrapper around /api/saved-searches.
 * Auth is added automatically by apiFetch.
 *
 * apiFetch returns { ok, status, data, requestId } — we unwrap data
 * and throw on !ok so callers can use try/catch.
 */
import { apiFetch, toUserError } from './httpClient';

function unwrap(r) {
  if (!r?.ok) {
    const err = new Error(toUserError(r) || 'Request failed');
    err.status = r?.status;
    err.data = r?.data;
    throw err;
  }
  return r.data;
}

export async function createSavedSearch({ filters, label } = {}) {
  const r = await apiFetch('/api/saved-searches', {
    method: 'POST',
    body: { filters: filters || {}, label: label || null },
  });
  return unwrap(r);
}

export async function listSavedSearches() {
  const r = await apiFetch('/api/saved-searches');
  return unwrap(r);
}

export async function deleteSavedSearch(searchId) {
  if (!searchId) throw new Error('searchId required');
  const r = await apiFetch(`/api/saved-searches/${searchId}`, { method: 'DELETE' });
  return unwrap(r);
}
